/* eslint-disable */

import {
  Box,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Badge,
} from "@chakra-ui/react";

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import * as React from "react";

import {
  MdCheckCircle,
  MdPendingActions,
  MdPriorityHigh,
} from "react-icons/md";

const columnHelper = createColumnHelper();

export default function ComplexTable(props) {
  const { tableData, title } = props;

  const [sorting, setSorting] = React.useState([]);
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const columns = [
    // ===============================
    // SUBJECT
    // ===============================
    columnHelper.accessor("subject", {
      header: () => (
        <Text fontSize="12px" color="gray.400">
          SUBJECT
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue()}
        </Text>
      ),
    }),

    // ===============================
    // CATEGORY
    // ===============================
    columnHelper.accessor((row) => row.category?.name, {
      id: "category",
      header: () => (
        <Text fontSize="12px" color="gray.400">
          CATEGORY
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm">
          {info.getValue() || "-"}
        </Text>
      ),
    }),

    // ===============================
    // STATUS
    // ===============================
    columnHelper.accessor("status", {
      header: () => (
        <Text fontSize="12px" color="gray.400">
          STATUS
        </Text>
      ),
      cell: (info) => {
        const value = info.getValue();

        const color =
          value === "selesai"
            ? "green"
            : value === "diproses"
            ? "orange"
            : "gray";

        return (
          <Badge colorScheme={color} variant="subtle">
            {value}
          </Badge>
        );
      },
    }),

    // ===============================
    // URGENSI
    // ===============================
    columnHelper.accessor("urgensi", {
      header: () => (
        <Text fontSize="12px" color="gray.400">
          PRIORITAS
        </Text>
      ),
      cell: (info) => {
        const value = info.getValue();

        const color =
          value === "tinggi"
            ? "red"
            : value === "sedang"
            ? "orange"
            : "green";

        return (
          <Flex align="center" gap="5px">
            {value === "tinggi" && (
              <Icon as={MdPriorityHigh} color="red.400" />
            )}
            <Badge colorScheme={color}>{value}</Badge>
          </Flex>
        );
      },
    }),

    // ===============================
    // DATE
    // ===============================
    columnHelper.accessor("created_at", {
      header: () => (
        <Text fontSize="12px" color="gray.400">
          TANGGAL
        </Text>
      ),
      cell: (info) => {
        const date = new Date(info.getValue());
        return (
          <Text fontSize="sm">
            {date.toLocaleDateString("id-ID")}
          </Text>
        );
      },
    }),
  ];

  const table = useReactTable({
    data: tableData || [],
    columns,
    state: { sorting },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <Card flexDirection="column" w="100%" px="0px">
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text color={textColor} fontSize="20px" fontWeight="700">
          {title}
        </Text>
        <Menu />
      </Flex>

        <Box w="100%" overflowX="auto">
          <Table
            variant="simple"
            color="gray.500"
            mb="24px"
            w="100%"
            sx={{ tableLayout: "fixed" }}
          >
          <Thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <Th
                    key={header.id}
                    borderColor={borderColor}
                    onClick={header.column.getToggleSortingHandler()}
                    cursor="pointer"
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>

          <Tbody>
            {table.getRowModel().rows.slice(0, 5).map((row) => (
              <Tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <Td key={cell.id} borderColor="transparent">
                    {flexRender(
                      cell.column.columnDef.cell,
                      cell.getContext()
                    )}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Card>
  );
}
